import axios from 'axios'
import { config } from '../Config/config'
const profileService = {
    getBio: (id) => {
        const result = axios.get(config.apiUrl + '/profile/biodata/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getSpes: (bio_id) => {
        const result = axios.get(config.apiUrl + '/profile/spes/' + bio_id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getTreat: (bio_id) => {
        const result = axios.get(config.apiUrl + '/profile/treat/' + bio_id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getRiwayat: (bio_id) => {
        const result = axios.get(config.apiUrl + '/profile/riwayat/' + bio_id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getuserfullname: (name) => {
        const result = axios.get(config.apiUrl + '/profile/user/' + name)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getuserphone: (phone) => {
        const result = axios.get(config.apiUrl + '/profile/user/phone/' + phone)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    updData: (body) => {
        console.log(body)
        const result = axios.put(config.apiUrl + '/profiles/update/', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getuseremail: (email) => {
        const result = axios.get(config.apiUrl + '/profile/user/email/' + email)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    getotp: (email) => {
        const result = axios.post(config.apiUrl + '/email/otp/' + email)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    updEmail: (body) => {
        console.log(body)
        const result = axios.put(config.apiUrl + '/profiles/email/update/', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    updPassword: (body) => {
        console.log(body)
        const result = axios.put(config.apiUrl + '/profiles/password/update/', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    resPassword: (body) => {
        console.log(body)
        const result = axios.post(config.apiUrl + '/profiles/resetpassword/', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
    updPhoto: (body) => {
        console.log(body)
        const result = axios.put(config.apiUrl + '/profiles/photo/', body)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },
}
export default profileService